import { secondAxios } from "../../../../../api/axios";

/**
 * Clients to pick a new project's prefix from - fetched lazily the first
 * time the "Add Project" dialog opens, not on every tree mount.
 */
export const fetchClients = async () => {
  try {
    const response = await secondAxios.get("/client");
    return Array.isArray(response.data) ? response.data : [];
  } catch {
    return [];
  }
};
